import { useMutation } from '@tanstack/react-query';
import { isError } from 'lodash';

import { Importer } from '@air/api';
import { INVALID_IMPORT_OPERATION, matchesAirror, NO_IMPORT_JOB } from '@air/errors';
import { useToasts } from '@air/provider-toast';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useRefreshImportTasks } from '~/swr-hooks/importer/useRefreshImportTasks';

export const useCancelImportMutation = () => {
  const { showToast } = useToasts();
  const { currentWorkspace } = useCurrentWorkspace();
  const { refreshImports } = useRefreshImportTasks();

  const mutation = useMutation({
    mutationFn: async (importId: string) => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }

      await Importer.deleteJob({
        workspaceId,
        importId,
      });
    },
    onSuccess: () => {
      showToast('Import has been cancelled.');
      refreshImports();
    },
    onError: (error: unknown) => {
      if (matchesAirror(error, NO_IMPORT_JOB)) {
        showToast('Import not found.', { color: 'red' });
      } else if (matchesAirror(error, INVALID_IMPORT_OPERATION)) {
        showToast('Import has already been completed.', { color: 'red' });
      } else {
        showToast(
          isError(error) ? error.message : 'There was an error cancelling the import. Please try again later.',
          { color: 'red' },
        );
      }
    },
  });

  return { mutation };
};
